module.exports = __webpack_public_path__ + "img/jdzxjc.969456a3.png";